import React from "react";
import Icons from "../../../../Constants/Icons";
import { useState } from "react";

const CheckingDetailsModel = ({
  checkingDetailShow,
  checkInEventSelect,
  setCheckingDetailShow,
  confirmDeleted,
}) => {
  const [previewMedia, setPreviewMedia] = useState(null);
  const handleClick = () => {
    setCheckingDetailShow(false);
  };
  const handleDeleted = (item) => {
    if (window.confirm("Are you sure you want to delete this media?")) {
      confirmDeleted(item);
    }
  };

  const openPreview = (item) => {
    setPreviewMedia(item);
  };

  const closePreview = () => {
    setPreviewMedia(null);
  };
  return (
    <>
      <div
        className={`modal-category CheckingDetails check_I ${
          checkingDetailShow ? "display-block" : "display-none"
        }`}
      >
        <div className="modal-content checking-details-model">
          <span className="close" onClick={handleClick}>
            &times;
          </span>
          <div
            className={`show ${
              checkingDetailShow ? "display-block" : "display-none"
            }`}
          >
            <div className="lastWeekEndDivGreyColor">Event Media</div>
            <div className="show">
              {checkInEventSelect?.media?.length != 0 ? (
                checkInEventSelect?.media?.map((item) => (
                  <>
                    <div className="check_width" style={{}}>
                      {item?.mediaUrl?.slice(item?.mediaUrl?.length - 4) !=
                      ".mp4" ? (
                        <div key={item.mediaId} className="media_menu">
                          <img
                            className="User-media"
                            onClick={() => openPreview(item)}
                            src={item.mediaUrl}
                            alt="User Media"
                          />
                          <img
                            className="delete_media"
                             style={{
                              margin:5,
                            }}
                            src={Icons.delete}
                            onClick={() => handleDeleted(item)}
                            alt="Delete Icon"
                          />
                          <div
                              className="play_button"
                              onClick={() => openPreview(item)}
                            >
                              <img
                                src={Icons.event_eye}
                                style={{
                                  height: "20px",
                                  cursor: "pointer",
                                  objectFit: "contain",
                                }}
                              />
                            </div>
                        </div>
                      ) : (
                        <div key={item.mediaId} className="media_menu">
                          <img
                            className="User-media"
                            onClick={() => openPreview(item)}
                            src={item.thumbnailUrl}
                            alt="User Media"
                          />
                          <img
                            className="delete_media"
                            src={Icons.delete}
                            style={{
                              margin:5,
                              height:15
                            }}
                            onClick={() => handleDeleted(item)}
                            alt="Delete Icon"
                          />
                            <div
                              className="play_button"
                              onClick={() => openPreview(item)}
                            >
                              <img
                                src={Icons.playButton}
                                style={{
                                  height: "20px",
                                  cursor: "pointer",
                                  objectFit: "contain",
                                }}
                              />
                            </div>
                        </div>
                      )}
                    </div>
                  </>
                ))
              ) : (
                <p className="no-media">No media available</p>
              )}
            </div>
          </div>
        </div>
      </div>

      {previewMedia && (
        <div className="preview-modal display-block">
          <div className="preview-content">
            <span className="close" onClick={closePreview}>
              &times;
            </span>
            {previewMedia.mediaUrl.endsWith(".mp4") ? (
              <video
                src={previewMedia.mediaUrl}
                controls
                autoPlay
                style={{ maxWidth: "100%", maxHeight: "80vh" }}
              />
            ) : (
              <img
                src={previewMedia.mediaUrl}
                alt="Preview"
                style={{ maxWidth: "100%", maxHeight: "80vh" }}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default CheckingDetailsModel;
